import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import {i18n} from '@/plugins/i18n'

const state = {
    templateDetails : {},
    languageList : {},
    passwordPolicy: {},
    generalCurrencySymbol: null,
};

const getters = {
    allTemplateDetails: (state) => state.templateDetails,
    getLayout: (state) => state.templateDetails.layout || 'normal',
    getLanguageList: (state) => state.languageList,
    getLoginLogoImage: (state) => state.templateDetails.loginLogoImage,
    getPasswordPolicy: (state) => state.passwordPolicy,
    getGeneralCurrencySymbol: (state) => state.generalCurrencySymbol
};

const actions = {
    async getTemplateDetails( context ){
            let businessUnit = JSON.parse(localStorage.getItem('clientConfig')) || {}
            if(businessUnit.businessUnitId) {
                businessUnit = businessUnit.businessUnitId
            } else {
                businessUnit = ''
            }

            return await axios.post(`${backendUrl()}/getClientSettings`, 
            {
                businessUnitId: businessUnit
            }).then(response =>{
                //Get all tempalte details if they dont exist in local storage
                context.commit('setTemplateDetails',response.data.clientConfigs)
                localStorage.setItem('templateDetails' , JSON.stringify(response.data.clientConfigs))

                //Get languages for translations if they dont exist in local storage
                context.commit('setLanguageList', response.data.clientConfigs.language_list)
                localStorage.setItem('languageList' , JSON.stringify(response.data.clientConfigs.language_list))

                // set password policy conditions
                context.commit('setPasswordPolicy', response.data.passwordPolicy)
                
                // set profile icon colour
                if(response.data.profileIconColour) {
                    context.commit('setProfileIconColour', response.data.profileIconColour)
                }
                context.commit('setMandatoryFields', response.data.mandatoryRegistrationFields)
                context.commit('setGeneralCurrencySymbol', response.data.generalCurrencySymbol)

                // in case we have no information stored about language get default english
                if (localStorage.getItem("currentTranslation") === null) {
                    localStorage.setItem('currentTranslation','EN')
                    i18n.setLocaleMessage('EN',response.data.clientConfigs.language.EN)
                }

                if(response.data.clientConfigs.name) {
                    return response.data.clientConfigs.name
                }
            }).catch(() => {
                alert('Unauthorised Access');
            })

    }
};

const mutations = {
    setTemplateDetails:(state, templateDetails) => (state.templateDetails = templateDetails),
    setLanguageList: (state, languageList) => (state.languageList = languageList),
    setNewsnetLogoStatus: (state, status) => (
      // We update the state in the local storage too
      // this is needed for the UI
      state.templateDetails.show_newsnet = status,
      localStorage.setItem('templateDetails', JSON.stringify(state.templateDetails))
    ),
    setLayout: (state, layout) => (
      // We update the state in the local storage too
      // this is needed for the UI
      state.templateDetails.layout = layout,
      localStorage.setItem('templateDetails', JSON.stringify(state.templateDetails))
    ),
    setNavbarLogoImage: (state, logoImage) => ( state.templateDetails.navbarLogoImage = logoImage),
    setNavbarBackgroundImage: (state, backgroundImage) => (state.templateDetails.navbarBackgroundImage = backgroundImage),
    setLoginLogoImage: (state, logoImage) => ( state.templateDetails.loginLogoImage = logoImage),
    setLoginBackgroundImage: (state, backgroundImage) => (state.templateDetails.loginBackgroundImage = backgroundImage),
    setPasswordPolicy: (state, policy) => (state.passwordPolicy = policy),
    setProfileIconColour: (state, profileIconColour) => (state.templateDetails.profileIconColour = profileIconColour),
    setPasswordHintStatus: (state, status) => (state.templateDetails.allow_password_hints = status),
    setMandatoryFields: (state, mandatoryFields) => (state.templateDetails.mandatoryFields = mandatoryFields),
    setGeneralCurrencySymbol: (state, generalCurrencySymbol) => (state.generalCurrencySymbol = generalCurrencySymbol),

};

export default {
  state,
  getters,
  actions,
  mutations
}
